import React from "react";
import NoDataFound from "../../common/NoDataFound";
import NextImage from "../../common/NextImage";

const EventTable = ({ data }) => {
  const displayCard = (type) => {
    const typeClasses = {
      "Yellow card": "card-yellow",
      "Red card": "card-red",
      "Second yellow card": "card-yellowred",
      Penalty: "penalty",
      Goal: "footbal-ico",
      "Own goal": "ongoal",
      "Disallowed goal": "var",
    };

    if (type === "HT" || type === "FT") return null;

    const cardClass = type === "Sub" ? "updown-arrow" : typeClasses[type] || "";
    return (
      <span className={type === "Goal" ? "football-bg" : ""}>
        <NextImage
          src={`/assets/images/svg/${cardClass}.svg`}
          width={12}
          height={12}
          alt={type}
        />
      </span>
    );
  };

  return (
    <div className="summary_table_wrp">
      {data?.length ? (
        <div className="global_table summary_table">
          <table>
            <tbody>
              {data?.map((event, index) => {
                const isHalfTimeOrFullTime =
                  event?.typ === "HT" || event?.typ === "FT";
                return (
                  <tr
                    key={`${event?.mins}-${index}`}
                  // className={isHalfTimeOrFullTime ? "active_row" : ""}
                  >
                    {isHalfTimeOrFullTime ? (
                      <>
                        <td>
                          <span className="brand_color">{event?.typ}</span>
                        </td>
                        <td></td>
                        <td>
                          <span className="badge">{event?.sc}</span>
                        </td>
                        <td></td>
                      </>
                    ) : (
                      <>
                        <td>
                          <span className="brand_color">{`${event?.mins}'`}</span>
                        </td>
                        {event?.isH === 0 || event?.isH === false ? (
                          <>
                            <td></td>
                            <td>
                              {event?.sc && (
                                <span className="badge">{event?.sc}</span>
                              )}
                            </td>
                          </>
                        ) : null}
                        <td>
                          <div className="teams_wrap">
                            <div className="teams-name">
                              <span className="team_name">
                                {/* {event?.sc && `(${event?.sc})`} */}
                                <span className="active">
                                  {event?.pl_nm || event?.pl_in_nm}
                                </span>
                              </span>
                              <span className="team_name">
                                {event?.pl_out_nm || event?.asst}
                              </span>
                            </div>
                            <div className="teams-logo">
                              {event?.typ && displayCard(event.typ)}
                            </div>
                          </div>
                        </td>
                        {event?.isH !== 0 && event?.isH !== false ? (
                          <>
                            <td></td>
                            <td></td>
                          </>
                        ) : null}
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default EventTable;
